import React, { useEffect } from "react";
import { Loading } from "./Loader";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { fetchMe, logout, selectAuth, selectIsAuthenticated } from "../features/auth/authSlice";

export function RequireStaff({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const isAuthed = useSelector(selectIsAuthenticated);
  const auth = useSelector(selectAuth);

  // Load user on first entry when we already have tokens
  useEffect(() => {
    if (isAuthed && !auth.user && auth.status === "idle") {
      dispatch(fetchMe());
    }
  }, [auth.status, auth.user, dispatch, isAuthed]);

  // If user is loaded and not staff => force logout and block access
  useEffect(() => {
    if (isAuthed && auth.user && auth.user.is_staff === false) {
      dispatch(logout());
    }
  }, [auth.user, dispatch, isAuthed]);

  if (!isAuthed) {
    return <Navigate to="/auth/login" state={{ from: location, reason: "not_authenticated" }} replace />;
  }

  // Same hard-reload behavior as RequireGroups: don't render protected UI until user is loaded.
  if (!auth.user && (auth.status === "idle" || auth.status === "loading")) {
    return <Loading text="Проверка доступа…" />;
  }

  if (!auth.user && auth.status === "failed") {
    return <Navigate to="/auth/login" state={{ from: location, reason: "failed_to_load_user" }} replace />;
  }

  if (auth.user && auth.user.is_staff === false) {
    return <Navigate to="/auth/login" state={{ reason: "not_staff" }} replace />;
  }

  return children;
}



